import { Pipe, PipeTransform } from '@angular/core';
import { AccountGroupLocationInterface } from '@vendasta/account-group';

@Pipe({ standalone: true, name: 'formatAddress' })
export class FormatAddressPipe implements PipeTransform {
  transform(address: AccountGroupLocationInterface): string {
    if (!address) {
      return '';
    }
    return [
      address.address?.trim(),
      address.address2?.trim(),
      [address.city?.trim(), address.state?.trim(), address.country?.trim()].filter((v) => !!v).join(', '),
      address.zip?.trim(),
    ]
      .filter((v) => !!v)
      .join('\n');
  }
}
